module.exports = __webpack_public_path__ + "static/media/pedidos_recurrentes.ca65c8eb.png";